<script>
import apolloMixin from "@/mixins/apollo.mixin";
import FocusGroupList from "@/views/settings/focus-group/index/_components/FocusGroupList.vue";
import { focusGroupQuery } from "@/views/settings/focus-group/index/gql/queries";

export default {
  name: "FocusGroup",

  components: { FocusGroupList },

  mixins: [apolloMixin],

  data() {
    return {
      featuresList: [],
    };
  },

  created() {
    this.getData();
  },

  methods: {
    async getData() {
      const { features } = await this.$get(focusGroupQuery);

      this.featuresList = features.map((feature) => {
        const { id, name, code, isActive, customers } = feature;

        return {
          id,
          name,
          code,
          customers: customers.length ? customers.map((customer) => customer.name).join(", ") : "-",
          isActive: isActive
            ? this.$t("focusGroup.isActive.activated")
            : this.$t("focusGroup.isActive.deactivated"),
        };
      });
    },

    onClickRow(id) {
      this.$router.push({ name: "FocusGroupEdit", params: { id } });
    },
  },
};
</script>

<template>
  <OurPage data-cy="users-page" :title="$t('title.focusGroup._')" gray>
    <FocusGroupList :items="featuresList" @onClickRow="onClickRow" />
  </OurPage>
</template>
